import { useTranslation } from 'react-i18next';

const statusColors: Record<string, { bg: string; text: string }> = {
  promoted: {
    bg: 'rgba(183, 217, 69, 0.1)',
    text: 'var(--success-dark)',
  },
  candidate: {
    bg: 'rgba(84, 148, 158, 0.1)',
    text: 'var(--secondary)',
  },
  active: {
    bg: 'rgba(84, 148, 158, 0.1)',
    text: 'var(--secondary)',
  },
  degraded: {
    bg: 'rgba(230, 168, 23, 0.1)',
    text: 'var(--warning)',
  },
  disabled: {
    bg: 'rgba(214, 69, 69, 0.1)',
    text: 'var(--destructive)',
  },
};

export function getStatusRowBg(status: string): string {
  return statusColors[status]?.bg || 'transparent';
}

export function StatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  const config = statusColors[status] || {
    bg: 'var(--background-muted)',
    text: 'var(--foreground-muted)',
  };
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
      style={{ backgroundColor: config.bg, color: config.text }}
      data-testid={`status-badge-${status}`}
    >
      {t(`dqs.status.${status}`, { defaultValue: status })}
    </span>
  );
}
